import type { SVGProps } from 'react'
import { Ref, forwardRef } from 'react'

const SvgCar02 = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    width="1.5rem"
    height="1.5rem"
    fill="none"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M19 10V6.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C17.48 3 16.92 3 15.8 3H8.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C5 4.52 5 5.08 5 6.2V10m0-1H2V8m17 1h3V8M6 13.5h.01m11.99 0h.01M6.8 10h10.4c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C22 12.28 22 13.12 22 14.8V18c0 .932 0 1.398-.152 1.765a2 2 0 0 1-1.083 1.083C20.398 21 19.932 21 19 21h-.6c-.372 0-.557 0-.713-.025a2 2 0 0 1-1.662-1.662C16 19.157 16 18.972 16 18.6c0-.093 0-.14-.006-.178a.5.5 0 0 0-.416-.416C15.54 18 15.493 18 15.4 18H8.6c-.093 0-.14 0-.178.006a.5.5 0 0 0-.416.416C8 18.46 8 18.507 8 18.6c0 .372 0 .557-.025.713a2 2 0 0 1-1.662 1.662C6.157 21 5.972 21 5.6 21H5c-.932 0-1.398 0-1.765-.152a2 2 0 0 1-1.083-1.083C2 19.398 2 18.932 2 18v-3.2c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C4.28 10 5.12 10 6.8 10Zm-.3 3.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm12 0a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z"
    />
  </svg>
)
const ForwardRef = forwardRef(SvgCar02)
export default ForwardRef
